module.exports = __webpack_public_path__ + "img/home.002d6386.svg";